import axios from 'axios';
import {Setup} from './Setup';

const API =  axios.create({
    baseURL: Setup.endpoint+"/"+Setup.version
});

const API_PAYMENT =  axios.create({
    baseURL: "https://jsonplaceholder.typicode.com"
});


export {API,API_PAYMENT};

